import request from "@common/request";
import { MgpPayload } from "@earned/wizard/dist";
import { useFormeBackendApi } from "@modules/forme/queries";
import { Entitlement } from "@modules/mgp-sso/types";
import { useQuery } from "react-query";

interface SamlResponse {
  samlResponse: string;
}

const samlResponseQueryOptions = {
  refetchOnWindowFocus: false,
};

const useCalculatorSamlResponse = ({
  entitlement,
}: {
  entitlement: Entitlement;
}) => {
  return useQuery(
    [entitlement],
    () =>
      request<SamlResponse>(
        "GET",
        `/api/mgp/saml/blocks?entitlement=${entitlement}`
      ),
    samlResponseQueryOptions
  );
};

const usePlayZoneSamlResponse = () => {
  return useQuery(
    "playZone",
    () => request<SamlResponse>("GET", "/api/mgp/saml/playzone"),
    samlResponseQueryOptions
  );
};

const useWhatAreYouAfraidOfSamlResponse = () => {
  return useQuery(
    "whatAreYouAfraidOf",
    () => request<SamlResponse>("GET", "/api/mgp/saml/wayao"),
    samlResponseQueryOptions
  );
};

const useMgpInfo = () => {
  return useFormeBackendApi<MgpPayload>({
    method: "GET",
    path: "/v1/clients/intake/money-guide-pro",
  });
};

export {
  usePlayZoneSamlResponse,
  useWhatAreYouAfraidOfSamlResponse,
  useCalculatorSamlResponse,
  useMgpInfo,
};
